export const valoresExibidosOffCanvasNotasVersao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTags: '',
  separadorObservacoes: '',

  //Específicos
  statusVersao: 'Status',
  dataPrevista: 'Data prevista',
  dataVersao: 'Data de publicação',
  tagVersao: 'Nome da versão (tag)',
  descricao: 'Descrição',
  link: 'Link GitHub',
};

export const headersNotasVersao = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'Status', width: 8, key: '' },
  { text: 'Data Prevista', width: 12, key: '' },
  { text: 'Data Publicação', width: 12, key: '' },
  { text: 'Versão', width: 15, key: '' },
  { text: 'Descrição', width: 65, key: '' },
];

export const fieldObjectNotasVersao = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
